import React from 'react';
import classNames from 'classnames';

import css from './IconProfile.module.css';

/**
 * Profile icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {boolean?} props.filled whether the icon is filled or outline
 * @returns {JSX.Element} SVG icon
 */
const IconProfile = props => {
  const { className, rootClassName, filled = false } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Profile"
    >
      {filled ? (
        <g fill="currentColor" stroke="none">
          <circle cx="12" cy="7" r="4" />
          <path d="M20,21 L20,19 C20,17.9391 19.5786,16.9217 18.8284,16.1716 C18.0783,15.4214 17.0609,15 16,15 L8,15 C6.9391,15 5.9217,15.4214 5.1716,16.1716 C4.4214,16.9217 4,17.9391 4,19 L4,21 Z" />
        </g>
      ) : (
        <g
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="7" r="4" />
          <path d="M20,21 L20,19 C20,17.9391 19.5786,16.9217 18.8284,16.1716 C18.0783,15.4214 17.0609,15 16,15 L8,15 C6.9391,15 5.9217,15.4214 5.1716,16.1716 C4.4214,16.9217 4,17.9391 4,19 L4,21" />
        </g>
      )}
    </svg>
  );
};

export default IconProfile;
